@if (!shortVersion) {
  <h3>{{ 'orderCost.orderSummary' | cxTranslate }}</h3>
}
@if (cart) {
  <div class="cx-summary-partials">
    @if (!shortVersion) {
      <div class="cx-summary-row">
        <div class="col-6 cx-summary-label">
          {{ 'orderCost.subtotal' | cxTranslate }}
        </div>
        <div class="col-6 cx-summary-amount">
          {{ cart.subTotal?.formattedValue }}
        </div>
      </div>
      <div class="cx-summary-row">
        <div class="col-6 cx-summary-label">
          {{
          (cart.deliveryCost?.formattedValue
          ? 'orderCost.shipping'
          : 'orderCost.estimatedShipping'
          ) | cxTranslate
          }}
        </div>
        <div class="col-6 cx-summary-amount">
          {{
          cart.deliveryCost?.formattedValue
          ? cart.deliveryCost.formattedValue
          : ('orderCost.toBeDetermined' | cxTranslate)
          }}
        </div>
      </div>
      @if (cart.net) {
        <div class="cx-summary-row">
          <div class="col-6 cx-summary-label">
            {{ 'orderCost.salesTax' | cxTranslate }}
          </div>
          <div class="col-6 cx-summary-amount">
            {{ cart.totalTax?.formattedValue }}
          </div>
        </div>
      } @else {
        <div class="cx-summary-row">
          {{
          cart.totalPriceWithTax?.value !== cart.totalPrice?.value
          ? ('orderCost.grossTax' | cxTranslate)
          : ('orderCost.grossIncludeTax' | cxTranslate)
          }}
          {{ cart.totalTax?.formattedValue }}.
        </div>
      }
    }
    <div class="cx-summary-row cx-summary-total order-summary__total">
      <div class="offset-6 col-3 col-sm-4 total">
        {{ 'orderCost.total' | cxTranslate }}
      </div>
      <div class="col-3 col-sm-2 amount">
        {{ cart.totalPriceWithTax?.formattedValue }}
      </div>
    </div>
    @if (!shortVersion) {
      @if (cart.totalDiscounts?.value > 0) {
        <div class="cx-summary-row">
          {{ 'orderCost.discount' | cxTranslate }}
          {{ cart.totalDiscounts?.formattedValue }}
        </div>
      }
    }
  </div>
}

<!--
<cx-promotions
  *ngIf="cart"
  [promotions]="cart.appliedOrderPromotions"
></cx-promotions>
-->

<!-- <ng-container *cxFeatureLevel="'1.3'">
<cx-applied-coupons
  [vouchers]="cart.appliedVouchers"
  [isReadOnly]="true"
></cx-applied-coupons>
</ng-container> -->
